const encodeParam = (key: string, value: string | undefined): string => {
  if (value === undefined || value === null) return `${key}=`;
  return `${key}=${encodeURIComponent(value)}`;
};

export const encodeParams = <
  // eslint-disable-next-line @typescript-eslint/ban-types
  TParameters extends {[key: string]: string | undefined} = {}
>(
  params: TParameters | string,
): string => {
  if (!params) return '';
  if (typeof params === 'string') {
    return params;
  }

  if (params instanceof String) {
    return params.toString();
  }

  return Object.keys(params)
    .filter(key => params[key])
    .map(key => encodeParam(key, params[key]))
    .join('&');
};
